import { useContext } from 'react';

import { AuthContext, type IAuthContextData } from '../contexts/auth';

export const useAuth = (): IAuthContextData => useContext(AuthContext);
